import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={26} height={26} rx={6} fill="#352A1F" />
    <path
      d="M20.852 15.8891V14.4076H21.4076C22.0059 14.4076 22.5188 13.8946 22.5188 13.2964L22.5186 10.7039C22.5186 10.1056 22.0058 9.59268 21.4075 9.59268H20.8519V8.11117C20.8519 7.51323 20.339 7 19.7407 7L4.92592 7.00013C4.32758 7.00013 4 7.55456 4 8.15274V15.8475C4 16.4457 4.32759 17 4.92592 17H19.7407C20.339 17 20.8519 16.4873 20.8519 15.889L20.852 15.8891ZM5.48167 15.8891C5.42742 15.8891 5.29643 15.7583 5.29643 15.7038V8.48162C5.29643 8.42737 5.42742 8.29638 5.48167 8.29638H19.3705C19.4249 8.29638 19.5558 8.42737 19.5558 8.48162V15.7038C19.5558 15.7582 19.425 15.8891 19.3705 15.8891H5.48167ZM5.66678 8.66686V15.5187H19.1853V8.71183L5.66678 8.66686Z"
      fill="#BC9B6A"
    />
    <path
      d="M12.0593 8.66626V11.7561L6.96289 10.3101L13.7185 15.333V12.2432L18.8149 13.6891L12.0593 8.66626Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
